import Jaco from "oc-modules/oc-jaco3d/arrangement/Jaco";
import Debugs from "oc-threejs/Debugs";
import Booth from "./Booth";
import InteriorSpace from "./InteriorSpace";
import Partslist from "./Partslist";

export default class Arrangement extends Jaco {
  constructor(...params) {
    super(...params);
    this.partslist = new Partslist(this);
    this.interiorSpace = new InteriorSpace(this);
  }

  booth = undefined;
  interiorSpace = undefined;

  selectedLocation = "All";

  popover = undefined;
  dialog = undefined;

  boothFloors = {};
  interiorRestraints = [];

  state = {
    exhibition: undefined,
    booth: undefined,
    selectedComb: undefined,
    colorSetsForForm: undefined,
    selectedColors: [],
    companyName: "",
    companyColor: "",
    poster1: {
      url: "",
      x: 50,
      y: 50,
      zoom: 50,
    },
    poster2: {
      url: "",
      x: 50,
      y: 50,
      zoom: 50,
    },
    logo1: {
      url: "",
      x: 50,
      y: 50,
      zoom: 50,
    },
    logo2: {
      url: "",
      x: 50,
      y: 50,
      zoom: 50,
    },
    userData: {},
  };

  createDefaultArrangement(params, configuration) {
    const configurationJson = configuration?.Json;
    const exhibition = APP.richMetadata.getDefaultExhibition(params?.exhibitionId);
    const booth = APP.richMetadata.getDefaultBooth(params?.boothId);
    const formsForBooths = booth?.FormsForBooths;
    const defaultComb = formsForBooths?.find((formsForBooths) => formsForBooths.Default);

    const colorSetsForForm = defaultComb?.Form?.ColorSetsForForms;
    const defaultSelectedColorsForColorsets = colorSetsForForm?.map((cfff) => {
      const color = cfff.ColorSet.ColorForColorSet.find((cfcs) => cfcs.Default);
      return {
        colorPrefix: cfff.MaterialPrefix,
        colorId: color.id,
        color: color.Color,
        articleId: color.Article.Artikelnummer,
      };
    });

    // Das ist ein wichtiger Prozess: Merge der Situation
    // Der InspirationenEditor macht das hier noch etwas komplexer
    // Es ist so, dass die Konfiguration nicht unbedingt Hoheit über das gesamte Arrangement hat
    // Es muss also gemerged werden
    // Dabei gilt:
    // Exhibition und Booth + Businesslogik definieren Möglichkeiten
    // Wenn die Konfiguration diese Möglichkeiten nicht unterstützt (z.B. weil Möglichkeiten später eingeschränkt wurden)
    // wird ein Merge durchgeführt. Dieser Merge kann dafür sorgen, dass die Konfiguration so nicht möglich ist, wie vorher konfiguriert.

    const mergedConfigurationJson = {
      arrangement: {
        ...configurationJson?.arrangement,
        state: {
          selectedColors: defaultSelectedColorsForColorsets,
          companyName: "",
          companyColor: "",
          poster1: {
            url: "",
            x: 50,
            y: 50,
            zoom: 50,
          },
          poster2: {
            url: "",
            x: 50,
            y: 50,
            zoom: 50,
          },
          logo1: {
            url: "",
            x: 50,
            y: 50,
            zoom: 50,
          },
          logo2: {
            url: "",
            x: 50,
            y: 50,
            zoom: 50,
          },
          userData: {},
          ...configurationJson?.arrangement.state,
          booth: booth.Name,
          combId: defaultComb.id,
          exhibitionName: exhibition.Name,
        },
      },
    };

    // Wenn der Booth eine Inspiration hat, dann muss alles was irgendwie dem Konfigurator hinzugefügt wurde, d.h. Interiors und Extras
    // persistiert werden. Bei der Preisberechnung muss das berücksichtigt werden.
    if (booth.Inspiration) {
      mergedConfigurationJson.arrangement.booth.Inspiration = booth.Inspiration;
      mergedConfigurationJson.arrangement.state.selectedColors.forEach(
        (sC) => (sC.basicEquipment = true)
      );
      mergedConfigurationJson.arrangement.booth.interiors?.forEach( i => {
        if(i.articleNumber.match(/basicEquip/i)) {
          i.basicEquipment = true
        }
      });
      mergedConfigurationJson.arrangement.booth.extras?.forEach( i => {
        if(i.articleNumber.match(/basicEquip/i)) {
          i.basicEquipment = true
        }
      });
    }

    this.fromJSON(mergedConfigurationJson);

    return mergedConfigurationJson;
  }

  resetBoothCustomization() {
    this.createDefaultArrangement(APP.parseParams(), null);
  }

  matchURLs() {}

  toJSON() {
    const json = super.toJSON();
    json.arrangement = { state: {} };
    _.forEach(this.state, (value, key) => {
      if(key.startsWith('poster') || key.startsWith('logo')) {
        json.arrangement.state[key] = value;
      }
    });

    json.arrangement.state.exhibitionName = this.state.exhibition?.Name;
    json.arrangement.state.booth = this.state.booth?.Name;
    json.arrangement.state.combId = this.state.selectedComb?.id;
    json.arrangement.state.companyName = this.state.companyName;
    json.arrangement.state.companyColor = this.state.companyColor;
    json.arrangement.state.selectedColors = this.state.selectedColors;
    json.arrangement.booth = this.booth?.toJSON();
    json.stammdaten = this.state.userData;
    json.partslist = JSON.parse(JSON.stringify(this.partslist.toJSON()));
    return json;
  }

  fromJSON(json) {
    super.fromJSON(json);
    this.state = json.arrangement.state;

    const exhibition = APP.richMetadata.metadata.Exhibitions.find(
      (e) => e.Name == json.arrangement.state.exhibitionName
    );
    const booth = APP.richMetadata.metadata.Booths.find(
      (b) => b.Name == json.arrangement.state.booth
    );
    const comb = APP.richMetadata.metadata.FormsForBooths.find(
      (e) => e.id == json.arrangement.state.combId
    );
    const selectedColors = json.arrangement.state.selectedColors.map((sC) => {
      if (_.isNumber(sC.color)) {
        return {
          ...sC,
          color: new THREE.Color(sC.color),
        };
      } else {
        return sC;
      }
    });

    this.state.exhibition = exhibition;
    this.state.booth = booth;
    this.state.selectedComb = comb;
    this.state.selectedColors = selectedColors;
    this.state.companyName = json.arrangement.state.companyName;
    this.state.companyColor = json.arrangement.state.companyColor;
    this.state.userData = {};
    this.updateBooth();
    
    if (json.arrangement.booth) this.booth?.fromJSON(json.arrangement.booth);
    this.updateBooth();
  }

  setExhibition(exhibition) {
    this.state.exhibition = exhibition;
    APP.dirty();
  }

  setBooth(booth, size) {
    this.state.booth = booth;
    this.state.booth.selectedSize = size;
    APP.dirty();
  }

  setDraggingInterior(interior) {
    this.draggingInterior = interior;
  }

  setSelectedComb(selectedComb) {
    this.state.selectedComb = selectedComb;
    const colorSetsForForm = selectedComb?.Form?.ColorSetsForForms;
    const defaultSelectedColorsForColorsets = colorSetsForForm?.map((cfff) => {
      const color = cfff.ColorSet.ColorForColorSet.find((cfcs) => cfcs.Default);
      return {
        colorPrefix: cfff.MaterialPrefix,
        colorId: color.id,
        color: color.Color,
        articleId: color.Article.Artikelnummer,
      };
    });
    this.setSelectedColors(defaultSelectedColorsForColorsets);
    APP.dirty();
  }

  setSelectedColors(selectedColors) {
    this.state.selectedColors = selectedColors;
    APP.dirty();
  }

  setPopover(popover) {
    this.popover = popover;
    APP.dirty();
  }

  setDialog(dialog) {
    this.dialog = dialog;
    APP.dirty();
  }

  changeCompName(newName) {
    this.state.companyName = newName.trim();
    const amount = newName.replaceAll(" ", "").length - 15;
    const article = APP.metadata.Artikel.find((a) => a.Artikelnummer == "Letter");
    APP.arrangement.booth.updateExtras(article, amount);
    APP.dirty();
  }

  clearBooth() {
    let count = this.booth.interiors.length;
    while (count > 0) {
      const i = this.booth.interiors[--count];
      this.booth.removeInterior(i);
      this.interiorSpace.addInterior(i);
      i.positionValid = false;
      i.jaco3d.onChangeInDragSelectHoverState();
    }
    // this.booth.interiors.forEach(i => {
    //   this.booth.removeInterior(i);
    //   this.interiorSpace.addInterior(i);
    // });
    APP.dirty();
  }

  update3d() {
    super.update3d();
    this.updateBooth();
    this.updateDraggingInterior();
    this.updateInteriorSpace();
    console.log("update3dArrangement", this.state);
  }

  updateInteriorSpace() {
    this.interiorSpace.update3d();
  }

  updateBooth() {
    if (this.state.selectedComb) {
      if (!this.booth) {
        this.booth = new Booth(this, this.state.selectedComb.Model.Key);
      } else if (this.booth?.key !== this.state.selectedComb.Model.Key) {
        this.booth.key = this.state.selectedComb.Model.Key;
      }
    }

    if (this.booth) {
      this.booth?.update3d({
        selectedColors: this.state.selectedColors,
      });
    }
  }

  updateDraggingInterior() {
    this.draggingInterior?.update3d();
  }

  updateLanguage() {
    this.state.exhibition = APP.metadata.Exhibitions.find( ex => ex.Name == this.state.exhibition.Name);
    this.state.booth = APP.metadata.Booths.find( booth => booth.Name == this.state.booth.Name);
    this.state.selectedComb = APP.metadata.FormsForBooths.find( ffb => ffb.id == this.state.selectedComb.id);
  }
}
